export function resourcePathBuilder(
  path: string,
  params?: Record<string, unknown>,
): string {
  return Object.entries(params ?? {}).reduce((newPath, [key, value]) => {
    return newPath.replace(`{${key}}`, value as string);
  }, path);
}
